var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from '../framework/Timeouts';
export class Sunbrite {
    constructor(socket, log) {
        this.socket = socket;
        this.apiState = 'username';
        this.channelPrevious = '1';
        this.closedCaptioning = '0';
        this.displayBlank = false;
        this.enter = '1';
        this.info = '0';
        this.menu = '1';
        this.power = false;
        this.tuner = '1';
        this.videoSelection = '1';
        this.volume = '50';
        this.volumeMute = false;
        this.timeouts = new Timeouts();
        this.apiAsyncHandlers = [
            {
                name: 'close captioning',
                regExp: /(%1CLCP)\s+(\d|\?)/i,
                callback: (match) => {
                    if (match[2] !== '?') {
                        this.closedCaptioning = match[2];
                        this.socket.send(`${match[1]}=OK`);
                    }
                    else {
                        this.socket.send(`${match[1]}=${this.closedCaptioning}`);
                    }
                },
            },
            {
                name: 'displayBlank',
                regExp: /(%1AVMT)\s+(\d+|\?)/i,
                callback: (match) => {
                    if (match[2] !== '?') {
                        // set
                        this.displayBlank = match[2] === '31';
                        this.socket.send(`${match[1]}=OK`);
                    }
                    else {
                        // query
                        this.socket.send(`${match[1]}=${this.displayBlank ? '31' : '30'}`);
                    }
                },
            },
            {
                name: 'info',
                regExp: /(%1INFO)\s+(\d+|\?)/i,
                callback: (match) => {
                    if (match[2] !== '?') {
                        // set
                        this.info = match[2];
                        this.socket.send(`${match[1]}=OK`);
                    }
                    else {
                        // query
                        this.socket.send(`${match[1]}=${this.info}`);
                    }
                },
            },
            {
                name: 'enter',
                regExp: /(%1ENTR)\s+(\d+|\?)/i,
                callback: (match) => {
                    if (match[2] !== '?') {
                        // set
                        this.enter = match[2];
                        this.socket.send(`${match[1]}=OK`);
                    }
                    else {
                        // query
                        this.socket.send(`${match[1]}=${this.enter}`);
                    }
                },
            },
            {
                name: 'menu',
                regExp: /(%1MENU)\s+(\d+|\?)/i,
                callback: (match) => {
                    if (match[2] !== '?') {
                        // set
                        this.menu = match[2];
                        this.socket.send(`${match[1]}=OK`);
                    }
                    else {
                        // query
                        this.socket.send(`${match[1]}=${this.menu}`);
                    }
                },
            },
            {
                name: 'channelPrevious',
                regExp: /(%1CHRT)\s+(\d+|\?)/i,
                callback: (match) => {
                    if (match[2] !== '?') {
                        // set
                        this.channelPrevious = match[2];
                        this.socket.send(`${match[1]}=OK`);
                    }
                    else {
                        // query
                        this.socket.send(`${match[1]}=${this.channelPrevious}`);
                    }
                },
            },
            {
                name: 'keypad digit',
                regExp: /%1NUMB\s+(\S+)/i,
                callback: (match) => {
                    this.socket.send(`%1NUMB=${match[1]}`);
                },
            },
            {
                name: 'tuner',
                regExp: /(%1ARCB)\s+(\d|\?)/i,
                callback: (match) => {
                    if (match[2] !== '?') {
                        this.tuner = match[2];
                        this.socket.send(`${match[1]}=OK`);
                    }
                    else {
                        this.socket.send(`${match[1]}=${this.tuner}`);
                    }
                },
            },
            {
                name: 'arrow',
                regExp: /(%1ARRO)\s+(\d)/i,
                callback: (match) => {
                    this.socket.send(`${match[1]}=OK`);
                },
            },
            {
                name: 'channelup down',
                regExp: /(%1CHNA)\s+(\d)/i,
                callback: (match) => {
                    this.socket.send(`${match[1]}=OK`);
                },
            },
            {
                name: 'mute',
                regExp: /(%1MUTE)\s+(\d+|\?)/i,
                callback: (match) => {
                    if (match[2] !== '?') {
                        // set
                        this.volumeMute = match[2] === '1';
                        this.socket.send(`${match[1]}=OK`);
                    }
                    else {
                        // Query
                        this.socket.send(`${match[1]}=${this.volumeMute ? '1' : '0'}`);
                    }
                },
            },
            {
                name: 'power',
                regExp: /(%1POWR)\s+(\d+|\?)/i,
                callback: (match) => {
                    if (match[2] !== '?') {
                        // set
                        this.power = match[2] === '1';
                        this.socket.send(`${match[1]}=OK`);
                    }
                    else {
                        // Query
                        this.socket.send(`${match[1]}=${this.power ? '1' : '0'}`);
                    }
                },
            },
            {
                name: 'video source',
                regExp: /(%1INPT)\s+(\d+|\?)/i,
                callback: (match) => {
                    if (match[2] !== '?') {
                        this.videoSelection = match[2];
                        this.socket.send(`${match[1]}=OK`);
                    }
                    else {
                        this.socket.send(`${match[1]}=${this.videoSelection}`);
                    }
                },
            },
            {
                name: 'volume',
                regExp: /(%1VOLU)\s+(\d+|\?)/i,
                callback: (match) => {
                    if (match[2] !== '?') {
                        this.volume = match[2];
                        this.socket.send(`${match[1]}=OK`);
                    }
                    else {
                        this.socket.send(`${match[1]}=${this.volume}`);
                    }
                },
            },
            {
                name: 'software version',
                regExp: /(%1SWVE)\s+\?/i,
                callback: (match) => {
                    this.socket.send(`${match[1]}=Feb 23 2024  17:03:49`);
                },
            },
            {
                name: 'invalidQueryOrSet',
                regExp: /(.+)[\s=]\??.*/i,
                callback: (match) => {
                    this.socket.send(`${match[1]}=ERR}`);
                },
            },
        ];
        this.authAsyncHandlers = [
            {
                regExp: /.+/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    if (this.apiState === 'username') {
                        this.apiState = 'password';
                        this.socket.send(`Password: `);
                        // Delay allows emulator to ignore the empty password and respond to allow the
                        // driver to continue connecting.
                        yield this.timeouts.delay(500);
                        this.apiState = 'authenticated';
                        this.socket.send(`********`);
                        this.socket.send(`Login Successfully!`);
                        this.asyncHandlers = this.apiAsyncHandlers;
                    }
                }),
            },
        ];
        this.asyncHandlers = this.authAsyncHandlers;
    }
    onInitialize() {
        return __awaiter(this, void 0, void 0, function* () {
            this.apiState = 'username';
            this.asyncHandlers = this.authAsyncHandlers;
            yield this.timeouts.delay(1000);
            this.socket.send(`Welcome MSD3686 Cmd!`);
            this.socket.send(`UserName: `);
        });
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.videoSelection === code)
                return;
            if (lowestCode === undefined || parseInt(code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = code;
            }
        }
        this.videoSelection = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '11';
    }
}
Sunbrite.emulatorType = 'socketEmulator';
Sunbrite.key = '-O33B4Sph-P7Vb3EhAUg';
